/* estados de la aplicacion author */
const state = {
  // para cargar home
  dataCompetition: null,
  dataTorneo: null,
  modalidadTorneo: null, // {modalidad, pointsWin, pointsTie, pointsLoser, pointsWo}
  globalMatches: [],
  globalStadiums: [], // comparte una lista de estadios regitados para partidos
  globalJornadas: [], // lista de jornadas generadas en base a varios partidos
  globalFixture: [], // lista de fixture de un torneo
}

export default state
